/** Router location state — Homepage scrolls to pricing then clears the URL. */
export const SCROLL_TO_PRICING_STATE = { scrollToPricing: true };

export const shouldScrollToPricing = (location) =>
  Boolean(location?.state?.scrollToPricing) ||
  (typeof window !== "undefined" && window.location.hash === "#pricing");

export const scrollToPricingSection = () => {
  document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" });
};
